<template>
    <HeaderContent title="Driver & Guide"/>
    <ActionContent ctaText="Staff" @action="modal = !modal "/>
    <AdminStatistics title="Driver & Guide Statistics" :data="statistics" />
    <DriverGuideForm :modal="modal" @updateModal="modal = !modal"></DriverGuideForm>
    <AdminDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>

</template>


<script>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import DriverGuideForm from './DriverGuideForm.vue';
import AdminDataTable from '@/components/DataTable.vue';
import AdminStatistics from '@/components/StatisticData.vue';
import driverGuideDummy from '@/dummy-data/driverGuide.js';
// import iconLevel from '../../../public/icons/arrow-comparison.svg';
import iconUser from '../../../public/icons/users-alt.svg';
import { ref,} from 'vue';

export default{
    name : 'DriverGuideIndex',
    components: {
        HeaderContent,
        ActionContent,
        DriverGuideForm,  
        AdminDataTable,
        AdminStatistics
    },
    setup(){
        const modal = ref(false)
        const statistics = ref([
            {
                label: 'Total',
                key: 'Driver',
                value: 3,
                color: 'info',
                icon: iconUser,
            },
            {
                label: 'Total',
                key: 'Guide',
                value: 3,
                color: 'info',
                icon: iconUser,
            },
        ]);
        const headers = ref([
            {key : 'id',label: 'Id',sortable: true,},
            {key : 'name', label : 'Name',sortable: true,},
            {key : 'position', label : 'Position',sortable: true,},
            {key : 'contact', label : 'Contact',sortable: true, },
            {key : 'address', label : 'Address',sortable: true,},
            {key : 'status', label : 'Status',sortable: true,},
            {key: 'action', label: 'Actions',}
        ])
        const customActions = ref([
        {
            label: ((item)=>item.status == 'Active' ? 'Deactivate' : 'Activate'),
            icon: ((item)=>item.status == 'Active' ? 'fas fa-user-slash' : 'fas fa-user-check'),
            variant: ((item)=>item.status == 'Active' ? 'secondary' : 'primary'),
            action: (item) => {

            console.log('Extra charge action clicked for:', item);
            // Implement your extra charge logic here
            }
        
        },
    
        {
            label: 'Edit',
            variant: 'success',
            icon: 'fas fa-edit',
            action: (item) => {
            console.log('Edit action clicked for:', item);
            // Implement your edit logic here
            }
        },
        {
            label: 'Delete',
            variant: 'danger',
            icon: 'fas fa-trash',
            action: (item) => {
            console.log('Delete action clicked for:', item);
            // Implement your delete logic here
            }
        },
    
    ])
    const data= driverGuideDummy
    return{
        modal,statistics,headers,customActions,data
    }
     
    }
  
}

</script>


